const { subtle } = globalThis.crypto;

export default subtle;
